import type { SVGProps } from "react"
const CheckCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16.0755 7.93219C15.6238 7.61436 15 7.72284 14.6822 8.17451L10.6504 13.9039L8.98994 12.0773C8.61843 11.6687 7.98598 11.6386 7.57733 12.0101C7.16867 12.3816 7.13855 13.014 7.51006 13.4227L10.0101 16.1727C10.2142 16.3973 10.5093 16.517 10.8123 16.4981C11.1152 16.4792 11.3931 16.3237 11.5678 16.0755L16.3178 9.32549C16.6356 8.87383 16.5272 8.25003 16.0755 7.93219Z"
      fill="currentColor"
    />
  </svg>
)
export default CheckCircleFilled
